export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13123.9d398f58.jpg";